import React from "react";
import { useCart } from "../../context/CartContext";
import { formatNaira } from "../../productsData";

export default function CartItem({ item }) {
  const { updateQty, removeItem } = useCart();

  return (
    <div className="cart-item">
      <img src={item.img} alt={item.name} className="cart-item-img" />
      <div className="cart-item-body">
        <div className="cart-item-name">{item.name}</div>
        {item.meta && <div className="cart-item-meta">{item.meta}</div>}
        <div className="qty-stepper qty-stepper-sm">
          <button type="button" onClick={() => updateQty(item.id, item.qty - 1)}>&minus;</button>
          <span>{item.qty}</span>
          <button type="button" onClick={() => updateQty(item.id, item.qty + 1)}>+</button>
        </div>
      </div>
      <div className="cart-item-side">
        <div className="cart-item-price">{formatNaira(item.price * item.qty)}</div>
        <button type="button" className="cart-item-remove" onClick={() => removeItem(item.id)}>
          Remove
        </button>
      </div>
    </div>
  );
}
